/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
var MapType;
(function (MapType) {
  MapType["MAPBOX"] = "mapbox";
  MapType["GOOGLE"] = "google";
})(MapType || (MapType = {}));
var MapQualifier;
(function (MapQualifier) {
  MapQualifier["ACTIVITY"] = "activities__activity";
  MapQualifier["AIRPORT"] = "transport__airport";
  MapQualifier["BOOKED"] = "booked";
  MapQualifier["BUS_STATION"] = "transport__busStation";
  MapQualifier["CAR"] = "lob_cars";
  MapQualifier["CAMERA"] = "camera_alt";
  MapQualifier["CONVENIENCE"] = "store__convenience";
  MapQualifier["CRUISE"] = "portOfCall";
  MapQualifier["CUSTOM"] = "custom";
  MapQualifier["ESS"] = "ess";
  MapQualifier["FLIGHTPATH"] = "flightPath";
  MapQualifier["FOCAL"] = "focal";
  MapQualifier["FOOD_AND_DRINKS"] = "service__foodAndDrinks";
  MapQualifier["FOOD_STORE"] = "service__foodStore";
  MapQualifier["GOOGLE"] = "google";
  // @deprecated use FOOD_STORE
  MapQualifier["GROCERY"] = "service__groceryStore";
  MapQualifier["HIDDEN"] = "hidden";
  MapQualifier["HOTEL"] = "lob_hotels";
  MapQualifier["LANDMARK"] = "placeOfInterest__landmark";
  MapQualifier["MEMBER_DEAL"] = "member_deal";
  MapQualifier["METRO_STATION"] = "transport__metroStation";
  MapQualifier["MINIPIN"] = "minipin";
  MapQualifier["NOT_CLUSTERED"] = "not_clustered";
  MapQualifier["OBFUSCATED"] = "obfuscate";
  MapQualifier["OBFUSCATED_PIN"] = "pinObfuscate";
  MapQualifier["OBFUSCATED_PRICE"] = "priceObfuscate";
  MapQualifier["OVER"] = "over";
  MapQualifier["PARKING"] = "service__parking";
  MapQualifier["PEOPLE"] = "activities__redeemingPoint";
  MapQualifier["PERSON"] = "person";
  MapQualifier["PINNED"] = "pinned";
  MapQualifier["POINT_OF_INTEREST"] = "tourism__placeOfInterest";
  MapQualifier["RECOMMENDED"] = "recommended";
  // @deprecated use FOOD_AND_DRINKS
  MapQualifier["RESTAURANT"] = "service__restaurant";
  MapQualifier["SAVED"] = "saved";
  MapQualifier["SPOTLIGHT"] = "spotlight";
  // @deprecated use METRO_STATION
  MapQualifier["TRANSIT"] = "transport__metroStation";
  MapQualifier["TRANSPORTATION"] = "transport__trainStation";
  MapQualifier["TRAVELER"] = "traveler";
  MapQualifier["VACATION_RENTAL"] = "vacation_rental";
  MapQualifier["VIEWED"] = "viewed";
  MapQualifier["PACKAGE"] = "lob_packages";
  MapQualifier["PRICE_ICON_MARKER"] = "price_icon_marker";
  MapQualifier["SELECTED_ON_LOAD"] = "selected_on_load";
})(MapQualifier || (MapQualifier = {}));
var MapIconType;
(function (MapIconType) {
  MapIconType["ACTIVITY"] = "lob_activities";
  MapIconType["AIRPORT"] = "lob_flights";
  MapIconType["BUS_STATION"] = "directions_bus";
  MapIconType["CAR"] = "lob_cars";
  MapIconType["CAMERA"] = "camera_alt";
  MapIconType["CHECK_CIRCLE"] = "check_circle";
  MapIconType["CONVENIENCE"] = "shopping_cart";
  MapIconType["CRUISE"] = "lob_cruise";
  MapIconType["FLIGHTPATH"] = "flightPath";
  MapIconType["FOOD_AND_DRINKS"] = "local_dining";
  MapIconType["FOOD_STORE"] = "shopping_cart";
  // @deprecated use FOOD_STORE
  MapIconType["GROCERY"] = "shopping_cart";
  MapIconType["HOTEL"] = "lob_hotels";
  MapIconType["LANDMARK"] = "place";
  MapIconType["METRO_STATION"] = "train";
  MapIconType["ONEKEYCOIN"] = "onekeycoin";
  MapIconType["PARKING"] = "local_parking";
  MapIconType["PEOPLE"] = "people";
  MapIconType["PERSON"] = "person";
  MapIconType["POI"] = "circle_filled";
  // @deprecated use FOOD_AND_DRINKS
  MapIconType["RESTAURANT"] = "local_dining";
  MapIconType["SAVED"] = "favorite";
  MapIconType["SOLD_OUT"] = "remove";
  MapIconType["SPOTLIGHT"] = "star";
  // @deprecated use METRO_STATION
  MapIconType["TRANSIT"] = "train";
  MapIconType["TRANSPORTATION"] = "train";
  MapIconType["VACATION_RENTAL"] = "lob_vacation_rentals";
  MapIconType["PACKAGE"] = "lob_packages";
})(MapIconType || (MapIconType = {}));
export { MapIconType, MapQualifier, MapType };